// extracted by mini-css-extract-plugin
module.exports = {"loadingIndicator":"passport_loading-indicator__2nBm-","page":"passport_page__1BVcc","pageWithDelay":"passport_page--with-delay__1ZEEc","fadePage":"passport_fade-page__3F_-8"};